import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./ArticleListing.scss";
import Loading from "../Loading/Loading";
import httpService from "../../common/http.service";


const ArticleListing = ({ articleId }) => {
  const { i18n } = useTranslation();
  const language = i18n.language.toUpperCase();
  const navigate = useNavigate();
  // const REACT_APP_DEV_ENDPOINT = process.env.REACT_APP_DEV_ENDPOINT;
  // const targetPosition = window.innerHeight * 0.75;
  // window.scrollTo({top: targetPosition,behavior: 'smooth'});
  const REACT_APP_ENDPOINT = process.env.REACT_APP_ENDPOINT;
  const url = `article?language=${language}&status=1&catid=${articleId}&mobile=true`;
  const DEFAULT_IMAGE = `${process.env.REACT_APP_IMG_URL}images/files-test/1734705843913.jpeg`;


  const { data: articleList, isLoading } = useQuery(
    [`articleList`, articleId],
    () => httpService.get(url).then((data) => data.data.data)
  );

  const [visibleArticles, setVisibleArticles] = useState(15);

  if (isLoading) {
    return <Loading />;
  }

  const loadMoreArticles = () => {
    window.scrollTo(0, 0);
    setVisibleArticles((prevVisibleArticles) => prevVisibleArticles + 15);
  };

  


  return (
    <div className="my-5">
      <h3
        style={{ color: "#f16334", fontFamily: "fantasy", textAlign: "center" }}
      >
        Articles
      </h3>

      <div className="mb-3 row g-5">
        {articleList?.length > 0 ? (
          articleList.slice(0, visibleArticles).map((article, index) => (
            <button
              onClick={() => navigate(`/article/${article._id}`)}
              key={index}
              className="col-lg-4 article-card-button"
            >
              <div className="shadow article-card">
                <img
                  alt="article"
                  src={article.image || DEFAULT_IMAGE}
                  className="article-card-img img-fluid"
                />
                <div
                  className="article-title-div"
                  style={{ backgroundColor: "#f16334" }}
                >
                  <p className="text-white article-title fw-semibold">
                    {article.name}
                  </p>
                </div>
              </div>
            </button>
          ))
        ) : (
          <div>
            <h2 style={{ color: "#f16334" }} className="fw-bold">
              No articles Found
            </h2>
          </div>
        )}
      </div>

      {/* Load More Button */}
      {articleList?.length > visibleArticles && (
        <div className="mt-5 text-center">
          <button
            className="btn btn-primary"
            onClick={loadMoreArticles}
            style={{ backgroundColor: "#f16334", border: "none" }}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default ArticleListing;
